import axios, { AxiosError } from 'axios'
import { ReactElement, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { useAuthDispatch } from '@percent/admin-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'
import { config } from '@percent/admin-dashboard/config'
import { SET_LOGOUT, TRIGGER_PERMISSIONS_REFETCH } from '@percent/admin-dashboard/context/auth/authReducer/authReducer'

export const percentClient = axios.create({
  baseURL: config.urls.api,
  withCredentials: true
})

export const WithAxios = ({ children }: { children: ReactElement }) => {
  const dispatch = useAuthDispatch()
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const pathnameRef = useRef('')

  if (!pathname.toLowerCase().startsWith('/expired-session')) pathnameRef.current = pathname + search

  useEffect(() => {
    percentClient.interceptors.response.use(
      responseConfig => responseConfig,
      (error: AxiosError) => {
        if (error?.response?.status === 401) {
          const searchParams = new URLSearchParams()
          searchParams.set('redirectTo', pathnameRef.current)

          dispatch({
            type: SET_LOGOUT
          })

          navigate(`/expired-session?${searchParams.toString()}`)

          return
        }

        if (error?.response?.status === 403) {
          // No leading slash, so a caller's own form of the url - with or without one - matches
          const isPermissionsRequest = error.config?.url?.includes('v1/admin/authorisation/permissions')

          if (!isPermissionsRequest) {
            dispatch({
              type: TRIGGER_PERMISSIONS_REFETCH
            })
          }
        }

        throw error
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}
